import { CategoriaImgFilterService } from '../services/categoria-img-filter.service';
import { Pipe, PipeTransform } from '@angular/core';
import { CategoriaElemento } from '../models/categoria-elemento.model';

@Pipe({
  name: 'categoriaImgFilter',
})
export class CategoriaImgFilterPipe implements PipeTransform {
  transform(categorias: CategoriaElemento[], tipo: any): unknown {
    console.log(tipo);
    let result: string[] = [];

    const odsLinks = this.categoriaImgFilterService.odsLinks;
    if (!!categorias) {
      categorias.forEach(CategoriaElemento => {
        if (
          tipo == CategoriaElemento.categoria.padre.tipo_clasificacion &&
          CategoriaElemento.categoria.padre.nivel === '0'
        ) {
          if (tipo == 'ods') {
            const odsNumber = CategoriaElemento.categoria.ods_number;
            result.push(
              `<a href="${odsLinks[odsNumber]}" target="_blank" rel="noopener noreferrer" class="ods-link" title="Ver más sobre ODS ${odsNumber}">
                <img width="90px" src="assets/img/ods/${odsNumber}.webp" alt="ODS ${odsNumber}" />
              </a>`,
            );
          } else {
            result.push(CategoriaElemento.categoria.nombre);
          }
        }
      });

      result.sort((a, b) => {
        if (tipo === 'ods') {
          const matchA = a.match(/\d+/);
          const matchB = b.match(/\d+/);

          if (matchA && matchB) {
            const numeroA = parseInt(matchA[0], 10);
            const numeroB = parseInt(matchB[0], 10);
            return numeroA - numeroB;
          } else {
            console.error("Error al extraer 'ods_number' de los elementos.");
            return 0;
          }
        } else {
          return 0;
        }
      });

      if (result.length == 0) {
        result.push('');
      }
    }
    if (tipo == 'ods') {
      return result.join('');
    } else {
      return result.join(' / ');
    }
  }

  constructor(private categoriaImgFilterService: CategoriaImgFilterService) {}
}
